import { render, staticRenderFns } from "./HomeScreenIcon.vue?vue&type=template&id=5bb84c32&"
import script from "./HomeScreenIcon.vue?vue&type=script&lang=js&"
export * from "./HomeScreenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports